import React, { useEffect, useState } from "react";

export default function NotificationCard({ notiData, isLast = false }) {
  const [theme, setTheme] = useState({
    color: "",
    placeText: "",
    iconSrc: "",
  });

  useEffect(() => {
    console.log("notiData : ", notiData);

    switch (notiData.placeType) {
      case 1:
        setTheme({
          ...theme,
          color: "text-[var(--color-orange)]",
          placeText: "ทานที่ร้าน",
          iconSrc: "/images/notification/icon-store-orange.svg",
        });
        break;
      case 3:
        setTheme({
          ...theme,
          color: "text-[var(--color-green)]",
          placeText: "เดลิเวอรี่",
          iconSrc: "/images/notification/icon-delivery-green.svg",
        });
        break;
      default:
        setTheme({
          ...theme,
          color: "text-[var(--color-blue)]",
          placeText: "กลับบ้าน",
          iconSrc: "/images/notification/icon-take-home-blue.svg",
        });
        break;
    }
  }, []);

  console.log("notiData.orderType : ", notiData.orderType);

  const isSuccess = notiData.orderType === "SUCCESS";
  const statusText = isSuccess ? "สำเร็จ" : "ยกเลิกรายการ";
  const statusColor = isSuccess
    ? "text-[var(--color-green)]"
    : "text-[var(--color-red)]";

  return (
    <div
      className={`flex p-[min(1.17vw,12px)] ${
        isLast ? "" : "border-b-[min(0.20vw,2px)]"
      } border-[#D9D9D9] relative`}
    >
      <div className="flex gap-[min(2.05vw,21px)] items-center pr-[min(6.84vw,70px)]">
        <div
          className={`aspect-square w-[min(5.08vw,52px)] h-fit rounded-full flex justify-center items-center
          ${
            isSuccess
              ? "bg-[#2dc76d] bg-opacity-20"
              : "bg-[#FF0000] bg-opacity-[20%]"
          }`}
        >
          {isSuccess ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-[min(2.5vw,25px)] h-[min(2.5vw,25px)]"
            >
              <path
                d="M9.55 18.2L3.65 12.3c-.39-.39-.39-1.01 0-1.4.39-.39 1.01-.39 1.4 0l4.25 4.25 9.65-9.65c.39-.39 1.01-.39 1.4 0 .39.39.39 1.01 0 1.4L9.55 18.2c-.39.4-1.01.4-1.4 0z"
                fill="#2dc76d"
              />
            </svg>
          ) : (
            <img
              className="aspect-[6/33] w-[min(0.59vw,6px)] h-fit object-contain"
              src="/images/notification/icon-alert-red.png"
              alt=""
            />
          )}
        </div>

        <div className="flex flex-col gap-[min(0.78vw,8px)]">
          <div className="text-16">
            <span className={`${statusColor} mr-[min(1.46vw,15px)]`}>
              {statusText}
            </span>
            {notiData.orderNo}
          </div>

          <div className={`${theme.color} text-12 flex items-center`}>
            <img
              className="aspect-square w-[min(1.27vw,13px)] h-fit object-contain mr-[min(0.49vw,5px)]"
              src={theme.iconSrc}
              alt=""
            />
            <div>
              {theme.placeText}
              <span className="ml-[min(0.68vw,7px)]">{notiData.info}</span>
            </div>
          </div>

          <div className="text-16">{notiData.orderItem}</div>
        </div>
      </div>

      <div className="leading-[1.2] text-10 text-[#8C8C8C] text-right absolute bottom-[min(0.29vw,3px)] right-[min(0.98vw,10px)]">
        <div>{notiData.date}</div>
        <div>{notiData.time}</div>
      </div>
    </div>
  );
}
